import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-436c091c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["accept"]
const _hoisted_2 = {
  key: 0,
  class: "file"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_File = _resolveComponent("File")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      ref: "input",
      type: "file",
      style: {"display":"none"},
      accept: _ctx.accept,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1),
    _createVNode(_component_Button, {
      type: "dashed",
      name: _ctx.name,
      onClick: _ctx.onClick
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["name", "onClick"]),
    _createTextVNode(" " + _toDisplayString(" ") + " "),
    (_ctx.file)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(_component_File),
          _createTextVNode(" " + _toDisplayString(_ctx.file.name), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}